import { useDispatch } from "react-redux";

import { useQuery } from "@tanstack/react-query";

import { apiThatThrows } from "containers/Request";
import { ApiResponse } from "types/api";

import { ManifestsFilter } from "./types";

export const useManifestsFilters = () => {
  const dispatch = useDispatch();

  return useQuery<ApiResponse<ManifestsFilter[]>>({
    queryKey: ["manifestsFilters"],
    queryFn: () =>
      dispatch(
        apiThatThrows.getFilters.action({
          cache: true,
        })
      ),
  });
};
